<script setup lang="ts">
import ErrorBoundary from '~/components/user-interface/error-boundary.vue';
import type { IGameCategory } from '~/interfaces/dto/games/response';

interface ICarouselProps {
  alias?: string;
  games?: Partial<IGameCategory>[];
  route?: string;
  displayShowAll?: boolean;
  verticalNavigation?: boolean;
  showTitle?: boolean;
  totalGames?: number;
  position?: number;
  category?: string;
}

const props = withDefaults(defineProps<ICarouselProps>(), {
  route: '',
  displayShowAll: true,
  verticalNavigation: false,
  alias: '',
  totalGames: 0,
  position: 0,
  category: '',
  games: null,
});

const slugify = useSlugify;
</script>
<template>
  <div v-if="!!games" class="grid grid-cols-1 gap-2">
    <ErrorBoundary component-boundary="" file="">
      <WinnersCategoryListCard
        v-for="(game, index) in props.games"
        :id="game.id"
        :key="index"
        :image="game?.tileImage"
        :title="game.name || game.gameName"
        :subtitle="`${game.provider}`"
        :game="game"
        :position="index"
        :likes-count="game.likesCount"
        :game-url-wrapper-props="{
          query: { gcc: slugify(props.category), p: String(index) },
        }"
      />
    </ErrorBoundary>
  </div>
</template>
